import styles from './SyllabusDownloadButton.module.css';

function isSafeSyllabusUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}

function SyllabusDownloadButton({ url, fullWidth = false }) {
  if (!isSafeSyllabusUrl(url)) return null;

  return (
    <a
      className={`${styles.button} ${fullWidth ? styles.fullWidth : ''}`}
      href={url}
      download
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className={styles.icon} aria-hidden="true">↓</span>
      Descargar temario
    </a>
  );
}

export default SyllabusDownloadButton;
